import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import './ReturnVisit.css';
import { IDIcon } from '../../Icons/Icons';
import EventEmitter from '../../Utilities/EventEmitter'
import Fade from 'react-reveal/Fade';
import ReactGA from 'react-ga';
import { sendToSalesFlow, setDigitalData } from '../../Utilities/Utils.js';

class ReturnVisit extends Component {

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()

        if (this.props.DGRStore.debugMode === false){
            //REQUIRE USER 
            if (!this.props.DGRStore.values.lead_number){
                this.props.DGRStore.clearValues()
                return this.props.history.push('');
            }else{
                EventEmitter.emit('event:end_point_reached');
                this.props.DGRStore.checkIn()
            }
        }

        setDigitalData( 'return visit', this.props.DGRStore.club_number );
    }

    featuredProductClicked = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Return Visit',
            action: 'Featured Product Select'
        });

        e.preventDefault();
        this.props.DGRStore.setProductID( e.currentTarget.name );
        //TODO - possibly bailout function if missing product_id and club_number 
        const { club_product_id, club_number } = this.props.DGRStore 
        const { lead_number, is_waiver_signed } = this.props.DGRStore.values;

        // No lead number means we don't have them signed in with a lead.
        if ( !lead_number ) {
            this.props.history.push('enter_pass');
        // Lead exists, but the waiver isn't signed yet.
        } else if ( !is_waiver_signed ) {
            this.props.history.push('sign_waiver');
        // Lead exists and waiver is signed. Check for product id.
        } else if ( club_product_id && club_number ) {
            sendToSalesFlow( club_product_id, club_number, this.props.DGRStore.values );
        // No product selected, so go home and reset.
        } else {
            this.props.DGRStore.clearValues();
            this.props.history.replace('');
        }
    }

    membershipOptionsClicked = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Return Visit',
            action: 'Membership Options'
        });
    }

    render(){
        const { first_name, days_left } = this.props.DGRStore.values
        var featuredProduct = this.props.DGRProductStore.featuredProduct 

        var sizeObj = {
            fontSize: 100 
        }

		return (
			<div className="">
                <div className="returnVisit">
			    <Fade>
                    <div className="dgrTitleText">
                        <h2>Welcome back {first_name}!</h2> 
                    </div>
                    <div className="returnVisitSubText">
                        You have <span className="returnVisitSubTextBold">{days_left} day{ days_left === 1 ? '' : 's' } left</span> on your guest pass.  
                    </div>
                    <br/>

                    <div className="returnVisitBox">
                        <div className="returnVisitIcon">
                            <IDIcon
                            nativeColor='#FFFFFF' className=""
                            style={sizeObj}
                            viewBox="0 0 179 108"
                            />
                        </div>
                        <div className="returnVisitBody">
                            Please show your pass and ID to someone at the front desk to check-in
                        </div>
                    </div>

                    <div className="returnBottomInfo">
                        <div className="leftBottomInfo">
                            Reach Your Goals.
                            <br/>
                            <span className="joinToday">Join Today.</span>
                        </div>

                        <div className="rightBottomInfo">
                            <Link className="topReturnButton" to="/membership_options" name={ featuredProduct.id } onClick={ this.featuredProductClicked }> 
                                <div className="leftSideButtonPrice">
                                    <div className="optionPriceReturn">
                                        {featuredProduct.monthly_dues}<span className="priceTag">/mo</span>
                                    </div>
                                </div>
                                <div className="rightSideButton">
                                    <div className="productTitle">
                                        { featuredProduct.name }
                                    </div>
                                    <div className="productAddage">
                                       12 month commitment required 
                                    </div>
                                </div>
                            </Link>
            
                            <Link className="bottomReturnButton" to="/membership_options" tabIndex="-1" onClick={ this.membershipOptionsClicked }>
                                See All Membership Options
                            </Link>
                        </div>
			        </div>
			    </Fade>
			    </div>
			</div>
		)
		}
}

ReturnVisit = inject('DGRStore', 'DGRBackgroundStore', 'DGRProductStore')(observer(ReturnVisit))     
export default ReturnVisit



// WEBPACK FOOTER //
// ./src/components/DGR/ReturnVisit/ReturnVisit.js